import styled from 'styled-components'

const NewsContainer = styled.div``

export { NewsContainer }
